export default {
  sections: {
    title: {
      title: 'Bestelling bevestigd',
      description: 'Je cadeaukaart is succesvol gekocht',
    },
    instructions: {
      title: 'Controleer je e-mail',
      description:
        'We hebben je cadeaukaartgegevens en bon naar je e-mailadres gestuurd. De cadeaukaartcode arriveert binnen 5-10 minuten.',
    },
    details: {
      total: 'Totaal',
      order_number: 'Bestelnummer',
    },
    footer: {
      help: 'Onze technologiepartner Foodamigos helpt ons cadeaukaarten te beheren. Als je de cadeaukaart niet ontvangt of niet kunt vinden, neem dan contact met hen op via {{email}}',
      questions: 'Voor algemene vragen over inwisseling kun je ons bereiken via {{email}}',
    },
  },
  buttons: {
    go_home: 'Terug naar home',
    download_pdfs: 'Cadeaukaart PDF downloaden',
  },
};
